import { render } from "./JointCommitteeEmailHistory.vue?vue&type=template&id=289da4e8&scoped=true"
import script from "./JointCommitteeEmailHistory.vue?vue&type=script&lang=js"
export * from "./JointCommitteeEmailHistory.vue?vue&type=script&lang=js"

import "./JointCommitteeEmailHistory.vue?vue&type=style&index=0&id=289da4e8&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-289da4e8"

export default script